import { render, staticRenderFns } from "./myAttention.vue?vue&type=template&id=a135c1d4&scoped=true"
import script from "./myAttention.vue?vue&type=script&lang=js"
export * from "./myAttention.vue?vue&type=script&lang=js"
import style0 from "./myAttention.vue?vue&type=style&index=0&id=a135c1d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a135c1d4",
  null
  
)

export default component.exports